import { useState } from "react";
import { MembersSearchDropdownWithServerId } from "../../members_search_dropdown_with_server_id";
import { RolesSearchDropdown } from "../roles_search_dropdown";
import { MentionsList } from "./mentions_list";

export function MentionsSection(props: {
	member_ids: string[];
	role_ids: string[];
	onMembersChange: (val: string[]) => void;
	onRolesChange: (val: string[]) => void;
	is_editing: boolean;
}) {
	const { is_editing } = props;

	if (!is_editing) {
		return (
			<div className="flex flex-wrap gap-2">
				<MentionsList
					role_mention_ids={props.role_ids}
					user_mention_ids={props.member_ids}
				/>
			</div>
		);
	}

	return (
		<div className="flex flex-col gap-2">
			<MembersSearchDropdownWithServerId
				selected_ids={props.member_ids}
				onUpdate={props.onMembersChange}
			/>
			<RolesSearchDropdown
				selected_ids={props.role_ids}
				handleChange={props.onRolesChange}
			/>
		</div>
	);
}
